import React, { useEffect, Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
import { CellularResetSection } from './components/CellularResetSection';
import { initMetaPixel } from './utils/metaPixel';
const WowMomentSection = lazy(() => import('./components/WowMomentSection').then(m => ({
  default: m.WowMomentSection
})));
const MirrorSection = lazy(() => import('./components/MirrorSection').then(m => ({
  default: m.MirrorSection
})));
const VillainSection = lazy(() => import('./components/VillainSection').then(m => ({
  default: m.VillainSection
})));
const SymptomsSection = lazy(() => import('./components/SymptomsSection').then(m => ({
  default: m.SymptomsSection
})));
const MechanismSection = lazy(() => import('./components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const FascinationsSection = lazy(() => import('./components/FascinationsSection').then(m => ({
  default: m.FascinationsSection
})));
const TwoPathsSection = lazy(() => import('./components/TwoPathsSection').then(m => ({
  default: m.TwoPathsSection
})));
const AuthorityStatementSection = lazy(() => import('./components/AuthorityStatementSection').then(m => ({
  default: m.AuthorityStatementSection
})));
const SocialProofSection = lazy(() => import('./components/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const FinalCtaSection = lazy(() => import('./components/FinalCtaSection').then(m => ({
  default: m.FinalCtaSection
})));
const SafetyNetSection = lazy(() => import('./components/SafetyNetSection').then(m => ({
  default: m.SafetyNetSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Defer Meta Pixel to after initial render
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => initMetaPixel());
    } else {
      setTimeout(() => initMetaPixel(), 2000);
    }
  }, []);
  return <main className="min-h-screen bg-background font-sans text-navy selection:bg-accent selection:text-white" data-id="element-0">
      {/* noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=793935510144655&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <CellularResetSection data-id="element-4" />
      <Suspense fallback={null} data-id="element-5">
        <WowMomentSection data-id="element-6" />
        <MirrorSection data-id="element-7" />
        <VillainSection data-id="element-8" />
        <SymptomsSection data-id="element-9" />
        <MechanismSection data-id="element-10" />
        <FascinationsSection data-id="element-11" />
        <TwoPathsSection data-id="element-12" />
        <AuthorityStatementSection data-id="element-13" />
        <SocialProofSection data-id="element-14" />
        <FinalCtaSection data-id="element-15" />
        <SafetyNetSection data-id="element-16" />
        <Footer data-id="element-17" />
      </Suspense>
    </main>;
}